<template>
  <div class="content">
    <div class="ruleBox" v-for="(state, i) in rule.array" :key="i">
      <div class="triple">
        <div v-for="(b,j) in indexToBoolArray(i)" :key="j"
             class="cell"
             :style="b ? aliveStyle : deadStyle">
        </div>
      </div>
      <div class="cell next"
           :style="state ? aliveStyle : deadStyle"
           @click="onClick(i)"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rule: {
      type: Object,
      required: true
    }
  },
  inject: ['config'],
  computed: {
    aliveStyle () {
      return {
        background: this.config.aliveColor
      }
    },
    deadStyle () {
      return {
        background: this.config.deadColor
      }
    }
  },
  methods: {
    indexToBoolArray (i) {
      return i.toString(2).padStart(3, 0).split('').map(item => item === "1")
    },
    onClick (index) {
      // calc new rule number if this state is changed.
      let newNumber = this.rule.array.reduce((acc, val, i) => {
        if (i === index) {
          val = val === 0 ? 1 : 0
        }
        return acc + val * Math.pow(2, i)
      }, 0)
      this.$emit('ruleChanged', newNumber)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: row-reverse;
  margin: 0 auto;
  justify-content: space-around;
}
.ruleBox {
  width: 70px;
}
.cell {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: solid 1px #222;
  margin-left:-1px;
  &.next {
    cursor: pointer;
  }
}

</style>
